<template>
  <div class="sys-log-page">
    <layout>
      <template v-slot:search>
        <div class="search-wrapper">
          <div class="title"><a-icon type="search" /> 数据筛选</div>
          <a-divider></a-divider>
          <a-space>
            <a-range-picker v-model="queryParam.date" />
            <a-input allow-clear placeholder="账号" v-model="queryParam.username" />
            <a-input allow-clear placeholder="备注" v-model="queryParam.remark" />
            <a-button type="primary" @click="search">查询</a-button>
            <a-button @click="resetSearch">重置</a-button>
          </a-space>
        </div>
      </template>

      <template v-slot:content>
        <a-table
          :scroll="{ x: true }"
          :columns="columns"
          :row-key="record => record.id"
          :data-source="data"
          :pagination="pagination"
          :loading="loading"
          @change="handleTableChange"
          :transform-cell-text="$helper.emptyFormat"
        >
          <div slot="ip" slot-scope="record">
            <a-tooltip>
              <template slot="title">{{ record.ip }}</template>
              <span :class="record.region ? '' : 'text-red'">
                {{ record.region || '定位失败' }}
              </span>
            </a-tooltip>
          </div>
          <div slot="remark" slot-scope="record">
            <a-tooltip>
              <template slot="title">{{ record.user_agent }}</template>
              <a-tag>UA</a-tag>
            </a-tooltip>
            <a-tag class="data-btn" @click="showData(record)">DATA</a-tag>
            {{ record.remark }}
          </div>
        </a-table>
      </template>
    </layout>
    <data-form
      v-if="showDataForm"
      :showDataForm.sync="showDataForm"
      :model="model"
    />
  </div>
</template>

<style lang="less" scoped>
@import 'SysLog';
</style>

<script>
import SysLog from './SysLog'
export default SysLog
</script>
